import * as React from 'react'
import { Icon, IconType, Link } from 'DVWebNodeUI'
import * as st from './shareIcons.module.scss'
import { popupWindowParams } from '../../utils/utils'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { logRefTag } from '../../utils/url'

export interface IShareIconsProps {
  shareIcons: WpsRuntime.atv.wps.ShareIconsModel
}

const SHARE_PREFIX = 'share-widget-'

// Currently used networks for the share widget
const NETWORKS: WpsRuntime.atv.wps.NetworkType[] = ['Email', 'Facebook', 'Twitter', 'Pinterest']

const NetworkToIconMap: Record<WpsRuntime.atv.wps.NetworkType, IconType> = {
  'Email': IconType.EMAIL,
  'Facebook': IconType.FACEBOOK,
  'Twitter': IconType.TWITTER,
  'Pinterest': IconType.PINTEREST
}

const onClickHandler = (reftag: string, url: string, target: string, width?: number, height?: number) =>
  (e: React.MouseEvent<HTMLElement> | React.MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault()
  logRefTag(reftag)
  window.open(url, target, popupWindowParams(width, height))
}

export const ShareIconsComp = (props: IShareIconsProps) => {

  const networkMap = props.shareIcons.networkMap

  const createShareIcon = (networkType: WpsRuntime.atv.wps.NetworkType) => {
    const { network, url, reftag, target, ariaText, width, height } = networkMap[networkType]
    const icon = NetworkToIconMap[networkType]
    const id = `${SHARE_PREFIX}${icon}`
    // When JS disabled or in full screen on MacOS a new tab will be opened on click
    return(
      <Link id={id} data-automation-id={id} data-testid={id} ariaLabel={ariaText} href={url} target={target}
                   key={icon} onClick={onClickHandler(reftag, url, target, width, height)}>
        <div className={st.shareIconWithName}>
          <Icon className={st.icon} use={icon}/>
          <p className={st.iconText}>{network}</p>
        </div>
      </Link>
    )
  }

  return (
    <div className={st.shareIcons}>
      {NETWORKS.map(networkType => createShareIcon(networkType))}
    </div>
  )
}

export const ShareIcons = ShareIconsComp
